import '@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'NavigationBar',
  components: {
    MdmLink,
    MdmIcon
  },
  props: {
    hashFirstCat: {
      type: String,
      default: null
    },
    navigation: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    openedMenu: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClickNav(item) {
      this.$emit('select-item', item);
    }
  }
};